<script setup lang="ts">
import { watch } from "vue";
import { RouterView } from "vue-router";
import ToastHost from "./components/ToastHost.vue";
import TooltipHost from "./components/TooltipHost.vue";
import SupportBanner from "./components/SupportBanner.vue";
import { state } from "./composables/chat";
import { session } from "./composables/session";
import { useTabTitle } from "./composables/tabTitle";
watch(
  () => state.theme,
  (v) => (document.documentElement.dataset.theme = v),
  { immediate: true },
);
useTabTitle();
</script>
<template>
  <RouterView v-slot="{ Component }"
    ><component :is="Component" :key="session.slug" /></RouterView
  ><SupportBanner /><ToastHost /><TooltipHost />
</template>
